import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Device } from '../../../models/device';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { getObjectDiff } from '../fuel-params-form/fuel-params-form.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ContactInfo, ContactInfoService } from '../../../services/contact-info.service';

@Component({
    selector: 'app-device-data-form',
    imports: [FormsModule, ReactiveFormsModule, CommonModule, NgxMaskDirective, InputTextModule, ButtonModule, DialogModule, TooltipModule],
    templateUrl: './device-data-form.component.html',
    styleUrl: './device-data-form.component.scss',
    providers: [provideNgxMask()]
})
export class DeviceDataFormComponent {
  formCard!: FormGroup;
  showInfoNip = false;
  @Input() device!: Device;
  @Output() onSaving: EventEmitter<any>= new EventEmitter<any>();
  @Output() onResponse: EventEmitter<any>= new EventEmitter<any>();
  showPlates = false;
  showMessageError = false;
  messagesError = ""
  hidePlates: boolean = false;
  data!: LoginUserModel;
  tokenAuth = "";
  allPlates: any[] = [];
  timeSpan: number = 0;
  allowGetPlates=false;
  messagePlacas="";
  platesHelpSelected:number[]=[];
   oldDevice!: Device;
  showConfirm = false;
  messageConfirm = '';
  changes:any = null;
  contact!: ContactInfo;
  constructor(private router: Router, private fb: FormBuilder, private service: DevicesService, private contactSvc: ContactInfoService) {
 
    this.data = JSON.parse(localStorage.getItem('data')!); 
    this.hidePlates = false;
    this.contactSvc.get().subscribe(c => this.contact = c);
  }
  public inputTransformFn = (value: unknown): string => String(value).toUpperCase();
  public outputTransformFn = (value: string | number | undefined | null): string =>
    String(value).toUpperCase();

  pattern = {
    K: {
      pattern: new RegExp("[A-Z0-9\-]"), //uppercase and lowercase alphanumerics only but optionnal
      optional: true
    },
  }

  ngOnInit() {
    this.loadTimeSpan();
    if (this.device == null) {
      this.router.navigate(['app/dispositivos']);
    }

   this.oldDevice = structuredClone(this.device);
    this.formCard = this.fb.group({
      user: new FormControl({ value: this.device ? this.device.name : '', disabled: true }, Validators.required),
      description: new FormControl({ value: this.device ? this.device.description : '', disabled: true }, Validators.required),
      plate1: new FormControl({ value: this.device ? this.device.plates : '', disabled: false }, [Validators.required, Validators.maxLength(10)]),
      plate2: new FormControl({ value: this.device ? this.device.plates2 : '', disabled: false }),
      department: new FormControl({ value: this.device ? this.device.department : '', disabled: false }),
      lastOdometer: new FormControl({ value: this.device ? this.device.lastOdometer : '', disabled: false }),
      ecoNum: new FormControl({ value: this.device ? this.device.economicNumber : '', disabled: false }),
      account: new FormControl({ value: this.device ? this.device.account : '', disabled: false }),

    });

    if (this.device.isMaster == 1 || this.device.description.toUpperCase().includes("MAESTRA") || this.device.deviceType == "TG" || this.device.deviceType == "M"){
      this.hidePlates=true;
      this.allowGetPlates=false;
    }else{
      this.allowGetPlates=true;
      this.loadPlatesAccount();
      this.hidePlates=false;
    }

  }

  get plate1() {
    return this.formCard.get('plate1') as FormControl;
  }
  get plate2() {
    return this.formCard.get('plate2') as FormControl;
  }




   showConfirmDialog(){
         this.device.plates= this.plate1.value;
      this.device.plates2 = this.plate2.value;
      this.device.department= this.formCard.get('department')!.value;
      this.device.lastOdometer= this.formCard.get('lastOdometer')!.value;
      this.device.economicNumber = this.formCard.get('ecoNum')!.value;
      this.device.account = this.formCard.get('account')!.value;
      if(this.allowGetPlates && this.plate2.value != ""){  
        this.device.allowSavePlates=true;
      }

       
      
        const fields = ["plates" ,"plates2","department","lastOdometer","economicNumber","account"];
        this.changes = getObjectDiff(this.oldDevice, this.device, fields);
      this.changes = this.changes.replace('plates', 'Placas');
      this.changes = this.changes.replace('plates2', 'Placa secundaria');
      this.changes = this.changes.replace('department', 'Departmento');
      this.changes = this.changes.replace('lastOdometer', 'Último odómetro');
      this.changes = this.changes.replace('economicNumber', 'No. Económico');
      this.changes = this.changes.replace('account', 'Cuenta contable');
     
  
  if(this.changes!=''){
    this.messageConfirm = `Se guardarán los siguientes cambios:<span class='text-sm'><br>${this.changes}</span><br><b> ¿Desea continuar?</b>`;
      this.showConfirm = true;
      }
  
    }






  saveCardData() {
    if (this.formCard.valid) {
      this.onSaving.emit(true);
     
   
      this.service.saveCardParams(this.device, this.data.Client_number, this.data.User_id, 'Usuario',this.data.UserType=='Administrator'?'Administrador de la cuenta':this.data.Name).subscribe({
        next: (resp: any) => {
          this.onSaving.emit(false);
          resp.isSave=true;
          if(resp.errorCode==1){
            this.showMessageError=true;
            this.messagesError=resp.errorDesc;

          }else{
            
             this.oldDevice = structuredClone(this.device);
            this.onResponse.emit(resp);
           
            
          }
        },
        error: (error: any) => {
          this.showMessageError = true;
          this.messagesError = error.error.error;
        }
      })

    } else {

      this.showMessageError = true;
      this.messagesError = ''
    }

  }

  loadPlatesAccount() {

    this.service.getPlates(this.device.cardId, this.data.Client_number).subscribe({
      next: (resp: any) => {
        this.allPlates = resp;

      }
    })
  }

  loadTimeSpan() {
    this.service.getPlatesTimeSpan().subscribe({
      next: (resp: any) => {
        this.timeSpan = resp;
        this.messagePlacas="No es posible modificar las placas. Solo se permite un cambio cada "+this.timeSpan+" meses. Para solicitar una excepción, contacte a " + (this.contact?.emails?.devices || 'dispositivos@xiga.com.mx');
        if (!this.validTimeSpan(1)) { this.plate1.disable(); }
        if (!this.validTimeSpan(2)) { this.plate2.disable(); }
      },
      error: (error: any) => {
        this.messagePlacas=error.error.error;
      }
    })
  }

  validatePlates(event: any) {
    var dom = this;
    let inputId = event.target.id;
    dom.showMessageError = false;
    dom.messagesError = "";
    if(inputId=='plate1'){
      if(event.target.value == this.plate2.value){
        dom.showMessageError = true;
        dom.messagesError = "Las placas no pueden ser iguales";
      }
      
      
    }else if(inputId=='plate2'){
      if(event.target.value == this.plate1.value){
        dom.showMessageError = true;
        dom.messagesError = "Las placas no pueden ser iguales";
      }

     
    }


    this.allPlates.forEach(function (plate, index) {

      if (plate.platesName == event.target.value && event.target.value != dom.plate2.value) {
        if (inputId == "plate1") {
          dom.showMessageError = true;
          dom.messagesError = "La placa principal ingresada ya existe";
        }
        else if (inputId == "plate2") {
          dom.showMessageError = true;
          dom.messagesError = "La placa secundaria ingresada ya existe";
        }

      }
    })
  }

  isMinimumDateTimeValue(eta: Date): Boolean {
    let d = new Date(eta);
    return d.getTime() === new Date('0001-01-01T00:00:00').getTime();
  }

  validTimeSpan(numberPlate: number) {
    let today = new Date();
    let plateCheck = numberPlate == 1 ? this.device.plateUpdateDate : this.device.plate2UpdateDate;
    
    
    if (!this.isMinimumDateTimeValue(plateCheck)){
      var countMonth = ((today.getFullYear() - new Date(plateCheck).getFullYear()) * 12) + today.getMonth() - new Date(plateCheck).getMonth();
 
      return countMonth >= this.timeSpan
    } else {
      return true;
    }



  }


  showHelp(plate:number){
    let index = this.platesHelpSelected.indexOf(plate);
    if(index>-1){
      this.platesHelpSelected.splice(index,1);
    }else{
      this.platesHelpSelected.push(plate);
    }
  }


}
